
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bookforceurbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Book Force Urbania on Rent in Pune ',
        heading: 'Amruta Travels: Book Force Urbania on Rent in Pune ',
        headingDescription: 'Book Force Urbania on Rent in Pune with Amruta Travels and enjoy a luxurious, comfortable, and hassle-free group travel experience. Perfect for corporate trips, family outings, weddings, school excursions, airport transfers, and weekend getaways, our 13-seater and 17-seater Force Urbania vans offer spacious interiors, air-conditioning, and modern amenities for a smooth journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures your Force Urbania rental in Pune is safe, convenient, and stylish, making group travel simple and enjoyable.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Book Force Urbania on rent in Pune",
    "description": "Book Force Urbania on rent in Pune for premium group travel with luxury seating, full air conditioning, spacious interiors, and smooth ride quality. Ideal for family trips, corporate travel, weddings, airport transfers, and long-distance journeys with experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Force Urbania booking Pune",
    "description": "Force Urbania booking service in Pune offering easy reservation, transparent pricing, flexible travel options, and reliable customer support for local, outstation, and corporate transportation needs."
  },
  {
    "name": "Book Urbania van in Pune",
    "description": "Book Urbania van in Pune for comfortable group transportation featuring push-back seats, ample legroom, luggage space, and professional drivers suitable for all travel purposes."
  },
  {
    "name": "Force Urbania on rent Pune booking",
    "description": "Force Urbania on rent Pune booking available for families, corporate teams, tourists, and event travel with timely service, clean vehicles, and premium travel comfort."
  },
  {
    "name": "Urbania van booking Pune",
    "description": "Urbania van booking in Pune offering hassle-free reservations for airport transfers, sightseeing, outstation tours, corporate events, and group travel with luxury comfort."
  },
  {
    "name": "Book Force Urbania Pune online",
    "description": "Book Force Urbania Pune online with quick confirmation, transparent pricing, flexible pickup locations, and professional service for stress-free travel planning."
  },
  {
    "name": "Urbania rental booking Pune",
    "description": "Urbania rental booking in Pune for city travel, long-distance journeys, corporate requirements, and family tours with reliable vehicles and trained drivers."
  },
  {
    "name": "Book Urbania on rent near me Pune",
    "description": "Book Urbania on rent near you in Pune with doorstep pickup, comfortable interiors, air conditioning, and dependable service for local and outstation travel."
  },
  {
    "name": "Book Force Urbania van Pune",
    "description": "Book Force Urbania van in Pune for premium group transport offering spacious seating, luggage handling, and smooth travel experience across city and highways."
  },
  {
    "name": "Book 17 seater Force Urbania Pune",
    "description": "Book 17 seater Force Urbania in Pune ideal for medium-sized groups, corporate teams, family trips, wedding guests, and comfortable outstation journeys."
  },
  {
    "name": "Book 13 seater Urbania Pune",
    "description": "Book 13 seater Urbania in Pune suitable for small groups, corporate travel, airport transfers, and city travel with luxury comfort."
  },
  {
    "name": "Book luxury Force Urbania Pune",
    "description": "Book luxury Force Urbania in Pune featuring premium interiors, executive seating, climate control, and professional chauffeurs for high-end travel requirements."
  },
  {
    "name": "Book AC Urbania van Pune",
    "description": "Book fully air-conditioned Urbania van in Pune ensuring comfortable travel in all weather conditions for local, corporate, and outstation trips."
  },
  {
    "name": "Book premium Urbania Pune",
    "description": "Book premium Urbania in Pune for luxury group travel with modern design, smooth suspension, safety features, and professional service."
  },
  {
    "name": "Book Force Urbania in Pune city",
    "description": "Book Force Urbania in Pune city for local travel, events, corporate movement, airport transfers, and group transportation with reliable service."
  },
  {
    "name": "Book Urbania in Pimpri Chinchwad",
    "description": "Book Urbania in Pimpri Chinchwad for industrial areas, corporate offices, family outings, and outstation journeys with spacious and comfortable vehicles."
  },
  {
    "name": "Book Force Urbania in Hinjewadi Pune",
    "description": "Book Force Urbania in Hinjewadi Pune for IT companies, corporate travel, conferences, meetings, and employee transportation with professional standards."
  },
  {
    "name": "Book Urbania van in Baner Pune",
    "description": "Book Urbania van in Baner Pune ideal for executives, families, airport transfers, and group travel with luxury comfort and punctual service."
  },
  {
    "name": "Book Force Urbania in Kharadi Pune",
    "description": "Book Force Urbania in Kharadi Pune for IT parks, corporate offices, airport travel, and business meetings with premium vehicles."
  },
  {
    "name": "Book Force Urbania Pune for airport transfer",
    "description": "Book Force Urbania in Pune for airport transfer offering timely pickup and drop, spacious luggage space, and stress-free travel experience."
  },
  {
    "name": "Book Urbania for outstation from Pune",
    "description": "Book Urbania for outstation travel from Pune suitable for long-distance journeys, hill stations, pilgrimages, and group tours with comfort and safety."
  },
  {
    "name": "Book Force Urbania for wedding Pune",
    "description": "Book Force Urbania for wedding travel in Pune for guest transportation, family movement, and event logistics with luxury interiors."
  },
  {
    "name": "Book Urbania for corporate travel Pune",
    "description": "Book Urbania for corporate travel in Pune covering meetings, conferences, offsites, seminars, and executive transport with professional service."
  },
  {
    "name": "Book Urbania for group travel Pune",
    "description": "Book Urbania for group travel in Pune ideal for families, friends, offices, and tour groups requiring spacious and comfortable transportation."
  },
  {
    "name": "Book Force Urbania Pune price",
    "description": "Book Force Urbania in Pune at competitive prices with transparent fare structure, flexible packages, and value-for-money premium travel."
  },
  {
    "name": "Book Urbania Pune per km rate",
    "description": "Book Urbania in Pune on per kilometer rate suitable for local usage, city travel, and customized travel plans."
  },
  {
    "name": "Affordable Force Urbania booking Pune",
    "description": "Affordable Force Urbania booking in Pune offering budget-friendly rates without compromising on comfort, safety, or service quality."
  },
  {
    "name": "Best Force Urbania booking service Pune",
    "description": "Best Force Urbania booking service in Pune providing reliable vehicles, experienced drivers, transparent pricing, and excellent customer support."
  },
  {
    "name": "Cheap Urbania booking Pune",
    "description": "Cheap Urbania booking in Pune ideal for cost-conscious travelers seeking premium group transportation at economical rates."
  },
  {
    "name": "Book 17 Seater Force Urbania on Rent in Pune",
    "description": "Book 17 seater Force Urbania on rent in Pune for corporate teams, family tours, wedding guests, and comfortable long-distance group travel."
  }
],
"tableData": [
  ["Book Force Urbania on rent in Pune", "Force Urbania booking Pune"],
  ["Book Urbania van in Pune", "Force Urbania on rent Pune booking"],
  ["Urbania van booking Pune", "Book Force Urbania Pune online"],
  ["Urbania rental booking Pune", "Book Urbania on rent near me Pune"],
  ["Book Force Urbania van Pune", "Book 17 seater Force Urbania Pune"],
  ["Book 13 seater Urbania Pune", "Book luxury Force Urbania Pune"],
  ["Book AC Urbania van Pune", "Book premium Urbania Pune"],
  ["Book Force Urbania in Pune city", "Book Urbania in Pimpri Chinchwad"],
  ["Book Force Urbania in Hinjewadi Pune", "Book Urbania van in Baner Pune"],
  ["Book Force Urbania in Kharadi Pune", "Book Force Urbania Pune for airport transfer"],
  ["Book Urbania for outstation from Pune", "Book Force Urbania for wedding Pune"],
  ["Book Urbania for corporate travel Pune", "Book Urbania for group travel Pune"],
  ["Book Force Urbania Pune price", "Book Urbania Pune per km rate"],
  ["Affordable Force Urbania booking Pune", "Best Force Urbania booking service Pune"],
  ["Cheap Urbania booking Pune", "Book 17 Seater Force Urbania on Rent in Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Premium Force Urbania for Group Travel",
    "WhyChoosedescription": "Amruta Travels offers Force Urbania on Rent in Pune, combining comfort, style, and reliability. Ideal for small to medium-sized groups, it ensures a luxurious travel experience."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and VIP Travel",
    "WhyChoosedescription": "Whether it’s a corporate event, family outing, or VIP transport, booking a Force Urbania guarantees spacious, comfortable, and elegant travel throughout Pune and beyond."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "The Force Urbania features plush seating, generous legroom, air conditioning, wide windows, and ample luggage space, making it perfect for both day trips and long journeys."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our trained drivers ensure a safe and smooth ride. They are experienced in operating the Force Urbania, providing punctual, professional, and courteous service for every trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Affordable Luxury",
    "WhyChoosedescription": "Enjoy the luxury of the Force Urbania at competitive rates. Amruta Travels provides clear, upfront pricing with no hidden charges, giving excellent value for group travel."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All Force Urbania vehicles are regularly serviced and sanitized, ensuring high standards of hygiene, safety, and comfort for every journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We offer customized travel plans, flexible pickup/drop-off points, and tailored routes to match your schedule, whether for city tours or outstation trips."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking a Force Urbania on rent in Pune is hassle-free. Our friendly support team assists you from booking to journey completion, ensuring a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book a Force Urbania on rent in Pune?',
    answer: 'Booking a Force Urbania on rent in Pune is simple. You can book online, call our support team, or visit our office, and we will help you select the ideal vehicle for your group.'
  },
  {
    question: 'What are the features of the Force Urbania?',
    answer: 'The Force Urbania comes with luxurious interiors, comfortable seating, air conditioning, large windows, ample luggage space, and modern amenities for a premium travel experience.'
  },
  {
    question: 'Is the Force Urbania suitable for outstation trips?',
    answer: 'Yes, the Force Urbania is ideal for both local and outstation trips, offering comfort, stability, and safety for long-distance journeys.'
  },
  {
    question: 'Does the rental include a driver?',
    answer: 'Yes, every Force Urbania rental comes with a professional, courteous driver who ensures a smooth and safe journey for all passengers.'
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained?',
    answer: 'Absolutely. All our Force Urbania vehicles are regularly serviced, cleaned, and maintained to provide maximum comfort, hygiene, and safety.'
  },
  {
    question: 'What is the cost of booking a Force Urbania in Pune?',
    answer: 'The cost depends on trip duration, distance, and any additional services. Contact Amruta Travels for a customized and transparent quote.'
  },
  {
    question: 'Can I choose multiple pickup and drop-off points?',
    answer: 'Yes, we provide flexible pickup and drop-off options and can customize the route according to your schedule and travel plan.'
  },
  {
    question: 'Why choose Amruta Travels for Force Urbania booking in Pune?',
    answer: 'Amruta Travels offers well-maintained Force Urbania vehicles, professional drivers, transparent pricing, and dedicated support, ensuring a comfortable and premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ravi Kulkarni',
    role: 'Corporate Manager, Pune',
    text: 'We booked a Force Urbania for a company outing. The vehicle was spacious, clean, and extremely comfortable. The driver was professional and punctual. Highly recommend Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Shreya Patil',
    role: 'Event Coordinator, Pune',
    text: 'Booked a Force Urbania for a family trip. The bus was luxurious and very comfortable. The ride was smooth, and the driver was courteous. Excellent service by Amruta Travels!',
    rating: 5
  }
];














































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Force Urbania on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/book-force-urbania-on-rent-pune.jpg",
  "description": "Book Force Urbania on rent in Pune with Amruta Travels for airport transfers, weddings, corporate travel, group tours, and outstation trips. Easy online Urbania booking in Pune for 13 and 17 seater luxury AC vans. Available in Pimpri Chinchwad, Hinjewadi, Baner, Kharadi, and across Pune city at affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/book-force-urbania-on-rent-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Book Force Urbania on Rent in Pune | Online Urbania Booking</title>
  <meta
    name="description"
    content="Book Force Urbania on rent in Pune with Amruta Travels. Online booking for 13 & 17 seater luxury AC Urbania vans for airport transfer, wedding, corporate & outstation travel at best prices."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/100.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookforceurbaniaonrentinpune;